import "./skeleton.scss";

import { FunctionComponent } from "react";

const CardSkeleton : FunctionComponent = () => {
    return (
        <div className="skeleton card">
            <div className="skeleton-line"></div>
            <div className="skeleton-line small"></div>
        </div>
    )
}

export default CardSkeleton;
